<template>
  <div class="card">
    <ui-loader v-if="inLoading || !account" />
    <div class="card-header">
      <h3>Account</h3>
    </div>
    <div class="card-body" v-if="account">
      <account-email-control
        :email="account.email"
        label="Email"
        button="Change"
        @action="changeCurrentEmail"
      />
    </div>
  </div>
</template>

<script>
import API from '../../../api'

import UiLoader from '../ui-kit/ui-loader.vue'

import AccountEmailControl from './controls/account-email-control.vue'
export default {
  name: 'account-emails',
  components: {
    UiLoader,
    AccountEmailControl
  },
  data() {
    return {
      inLoading: false
    }
  },
  computed: {
    account() {
      return this.$store.getters.account
    },
    accountEmail() {
      return this.account && this.account.email
    }
  },
  methods: {
    async changeCurrentEmail(email) {
      this.inLoading = true
      try {
        await API.account.emailUpdate({ email })
        this.$store.dispatch('fetchAccount')
      } catch (err) {
        console.error(err)
      } finally {
        this.inLoading = false
      }
    }
  }
}
</script>

<style></style>
